/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';
import { getSearchParamKey } from '@toucan/common/services/search/helpers';
import {
    FilterQuery,
    SelectedFilters,
} from '@toucan/common/services/search/types';

import { SearchParam } from '@toucan/client/global/nextjs';

import {
    Filter,
    FilterOption,
} from '@toucan/client/features/search/components/model-search-results/types';

export const getSelectedFiltersFromQueryString = (
    filter: Filter,
    selectedFilters: SelectedFilters
) => {
    const selectedValues = selectedFilters[filter.id];

    return filter.values.filter((value) => {
        if (Array.isArray(selectedValues)) {
            return selectedValues.includes(value.value.toString());
        }

        return selectedValues === value.value;
    });
};

export function transformFiltersToSearchParams(
    filter: Filter,
    selectedItems: FilterOption[],
    filterQuery: FilterQuery
): SearchParam {
    const additionalQuery: Record<string, string> = {};

    const updatedFilterQuery = { ...filterQuery };

    const filterKey = getSearchParamKey(filter.id);

    updatedFilterQuery[filterKey] = selectedItems.map((item: FilterOption) =>
        item.value.toString()
    );

    const variant = selectedItems.find((item) => item.variant)?.variant;
    if (variant) {
        additionalQuery[filter.id] = variant;
    }

    return { ...updatedFilterQuery, ...additionalQuery };
}

export function transformSelectedFiltersToSearchParams(
    selectedFilters: Record<SearchFacet, Filter>
): SearchParam {
    const selectedFilterValues = Object.values(selectedFilters ?? []);

    return selectedFilterValues.reduce((searchParams, filter) => {
        const searchParamsForFilter = transformFiltersToSearchParams(
            filter,
            filter.values,
            searchParams
        );

        return { ...searchParams, ...searchParamsForFilter };
    }, {});
}

export function getMultipleSelectedFiltersFromQueryString(
    filters: Filter[],
    selectedFilters: SelectedFilters
) {
    return filters.reduce<Record<SearchFacet, Filter>>(
        (filters, filter) => {
            const selectedValues = getSelectedFiltersFromQueryString(
                filter,
                selectedFilters
            );

            if (selectedValues.length) {
                filters[filter.id] = {
                    ...filter,
                    values: selectedValues,
                };
            }

            return filters;
        },
        {} as Record<SearchFacet, Filter>
    );
}

export function getFiltersThatHaveBeenCleared(
    selectedFilters: SelectedFilters,
    searchParams: SearchParam
) {
    return Object.keys(selectedFilters).filter((key) => {
        const filterKey = getSearchParamKey(key);
        return !searchParams[filterKey];
    });
}

export function transformClearedFiltersToSearchParams(
    clearedFilters: string[]
): SearchParam {
    return clearedFilters.reduce(
        (searchParams, filter) => {
            const filterKey = getSearchParamKey(filter);
            searchParams[filterKey] = undefined;

            return searchParams;
        },
        {} as Record<string, undefined>
    );
}
